let UTILS = require("../libs/utils.js");
var v7685;
var v7686;
module.exports = {
  id: "hide",
  name: "Hide & Seek",
  alias: "hide",
  endStats: ["sid", "name", "score", "found", "reward"],
  winCondition: function (game) {
    var vLN01171 = 0;
    for (var vLN01172 = 0; vLN01172 < game.players.list.length; ++vLN01172) {
      if (game.players.list[vLN01172].active && game.players.list[vLN01172].team == 1) {
        vLN01171++;
      }
    }
    if (vLN01171 > 0) {
      return 1;
    } else {
      return 2;
    }
  },
  condition: [function (game) {
    var vLN01173 = 0;
    for (var vLN01174 = 0; vLN01174 < game.players.list.length; ++vLN01174) {
      if (game.players.list[vLN01174].active && game.players.list[vLN01174].team == 1) {
        vLN01173++;
      }
    }
    return vLN01173 > 0;
  }],
  minPlayers: 2,
  waitTimers: [{
    time: 10000,
    msg: "picking seeker in ",
    trigger: function (p9066) {
      p9066.pickSeeker();
    }
  }, {
    time: 45000,
    msg: "releasing seeker in ",
    trigger: function (p9067) {
      p9067.releaseSeeker();
    }
  }],
  spdMlt: {
    1: 0.8
  },
  teams: true,
  teamOptions: ["Hiders", "Seekers"],
  killConv: true,
  noKick: true,
  showTeam: true,
  viewDis: 2000,
  convTeam: 2,
  convWord: "found",
  noWeap: true,
  friendly: true,
  hideNames: true
};